
import { Component, Vue } from "vue-property-decorator";
import { TRANSLATIONS_FETCH } from "@/store/ActionTypes";
import { mapState } from "vuex";
import vModal from "@/components/vModal.vue";
import SubscriptionRepository from "@/utils/API/SubscriptionRepository";
import RecipesRepository from "@/utils/API/RecipesRepository";
import DishesRepository from "@/utils/API/DishesRepository";

@Component({
  components: {
    vModal,
  },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
      accountState: (state: any) => state.AccountModule,
    }),
  },
})
class ManageLimits extends Vue {
  localizationState: any;
  accountState: any;

  loading: boolean = false;

  recipes: any = [];
  dishes: any = [];
  subscriptionPackageRecipesLimit: number = 0;
  subscriptionPackageDishesLimit: number = 0;

  selectedRecipes: any = [];
  selectedDishes: any = [];

  // Get Recipes and Dishes arrays
  loadRecipesAndDishes() {
    SubscriptionRepository.recipeDishLimitExceededDetails()
      .then((response) => {
        this.recipes = response.data.result.recipes;
        this.dishes = response.data.result.dishes;
        this.subscriptionPackageRecipesLimit =
          response.data.result.subscriptionPackageRecipesLimit;
        this.subscriptionPackageDishesLimit =
          response.data.result.subscriptionPackageDishesLimit;
      })
      .catch((error) => {
        if (error.response)
          this.$snotify.error(
            error.response.errorMessages[0].userVisibleMessage
          );
        else this.$snotify.error(this.translations.get("network-error"));
      });
  }

  // Deleting recipes and dishes
  deleteRecipesAndDishes() {
    // Check
    if (
      this.selectedRecipes.length <
      this.recipes.length - this.subscriptionPackageRecipesLimit ||
      this.selectedDishes <
      this.dishes.length - this.subscriptionPackageDishesLimit
    ) {
      this.$snotify.error("You must select more recipes/dishes", {
        timeout: 2000,
      });
      return;
    }
    // Delete recipes
    this.loading = true;
    // @ts-ignore
    this.$snotify.async(
      "Deleting recipes and dishes..",
      () =>
        new Promise<void>((resolve, reject) => {
          RecipesRepository.deleteRecipes({
            recipeIds: this.selectedRecipes,
          })
            .then(() => {
              this.selectedRecipes.length = 0;

              // Delete dishes
              DishesRepository.deleteDishes({
                dishIds: this.selectedDishes,
              })
                .then(() => {
                  this.selectedDishes.length = 0;
                  this.loading = false;
                  setTimeout(() => {
                    (<any>window).location = "/";
                  }, 2000);
                  resolve();
                })
                .catch((error) => {
                  if (error.response)
                    this.$snotify.error(
                      error.response.errorMessages[0].userVisibleMessage
                    );
                  else
                    this.$snotify.error(this.translations.get("network-error"));

                  reject();
                });
            })
            .catch((error) => {
              if (error.response)
                this.$snotify.error(
                  error.response.errorMessages[0].userVisibleMessage
                );
              else this.$snotify.error(this.translations.get("network-error"));
            });
        }),
      {
        timeout: 1000,
        closeOnClick: true,
      }
    );
  }

  get translations() {
    return this.localizationState.translations;
  }

  created() {
    this.$store.dispatch(TRANSLATIONS_FETCH, {
      category: "pages",
      collections: ["packages", "common"],
    });

    document.title = "Limits | MenuSano";
    this.loadRecipesAndDishes();
  }
}
export default ManageLimits;
